import { getCurrentCulture, httpClient, mapObjectToUrlEncoded } from "@utils";
import { BankIdUserInfoDto } from "@api-types/integrations/BankIdUserInfoDto";
import { BankIdWidgetDto } from "@api-types/integrations";
import { BankIdApiAuthDto } from "@api-types/integrations/BankIdApiAuthDto";
import { BankIdSessionStatusDto } from "@api-types/integrations/BankIdSessionStatusDto";
import { ApiRequestContextData } from "@utils/api-config/types";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { getApiRequestContext } from "@utils/api-config";

export class BankIdApiService {
	static get baseUrl(): string {
		return `${WEBPACK_BASE_ADDRESS}platform/integrations/bankid`;
	}

	static getRequestHeaders = (
		context: ApiRequestContextData | null = getApiRequestContext()
	): HeadersInit => {
		const appHeaders = getApplicationRequestHeaders(context);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static async bankIdApiAuth(
		successRedirectUrl: string,
		failureRedirectUrl: string
	): Promise<BankIdApiAuthDto> {
		const lng = getCurrentCulture() === "sv" ? "sv" : "en";
		const body = {
			language: lng,
			successRedirectUrl,
			failureRedirectUrl,
		};

		return await httpClient.post(
			`${this.baseUrl}/auth/api-authentication`,
			JSON.stringify(body),
			this.getRequestHeaders()
		);
	}

	static async getBankIdWidgetInfo(
		device: "same-device" | "other-device",
		successRedirectUrl: string,
		failureRedirectUrl: string
	): Promise<BankIdWidgetDto> {
		const lng = getCurrentCulture() === "sv" ? "sv" : "en";
		let body = {
			language: lng,
			successRedirectUrl,
			failureRedirectUrl,
		};

		return await httpClient.post(
			`${this.baseUrl}/auth/widget-${device}`,
			JSON.stringify(body),
			this.getRequestHeaders()
		);
	}

	static async getSessionStatus(
		requestId: string,
		isLogin: boolean = false
	): Promise<BankIdSessionStatusDto> {
		return await httpClient.get(
			`${this.baseUrl}/auth/session-status/${requestId}?isLogin=${isLogin}`,
			this.getRequestHeaders()
		);
	}

	static async getUserAdditionalInfo(formData: {
		sessionId: string;
	}): Promise<BankIdUserInfoDto> {
		const headers = this.getRequestHeaders();
		headers["Content-Type" as keyof HeadersInit] =
			"application/x-www-form-urlencoded";

		const body = mapObjectToUrlEncoded(formData);

		return await httpClient.post(
			`${this.baseUrl}/auth/resolve-user-info`,
			body,
			headers
		);
	}
}
